import axios from 'axios'
import { useState } from 'react'
import authService from '../../../Components/Login/auth.service'
import '../../../styles/pages/MenuDireito/modal/ModalFuncaoEPermissao.css'

export default function ModalClassificacao({ setOpenModal, modalInfo }) {
  var user = authService.getCurrentUser()
  function handleInputChange(event) {
    if (event.target.name === 'clsStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  let newDate = new Date()
  const [campos, setCampos] = useState({
    IdClassificacao: modalInfo.IdClassificacao,
    IdEmpresa: modalInfo.IdEmpresa,
    clsDescricao: modalInfo.clsDescricao,
    clsObservacoes: modalInfo.clsObservacoes,
    clsStatus: modalInfo.clsStatus,
    clsAlteradoPor: user[0].pesEmail,
    clsAlteradoEm: newDate
  })
  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .put(
        process.env.REACT_APP_API_URL +
        '/api/v1/classificacao/' +
        campos.IdClassificacao,
        campos
      )
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }

  return (
    <>
      <div
        onClick={() => {
          setOpenModal(false)
        }}
        className="overlay"
      ></div>
      <div className="modalPadrao-content">
        <div className="cxTituloPadrao">
          <h1>
            Editar Classificação
            <hr className="hrTitleModal" />
          </h1>
          <button
            onClick={() => {
              setOpenModal(false)
            }}
          >
            X
          </button>
        </div>
        <form onSubmit={handleFormSubmit}>
          <label>Descrição:</label>
          <input
            type="text"
            id="fname"
            defaultValue={campos.clsDescricao}
            name="clsDescricao"
            onChange={handleInputChange}
          ></input>
          <label>Observações:</label>
          <textarea
            type="text"
            id="fname"
            defaultValue={campos.clsObservacoes}
            name="clsObservacoes"
            onChange={handleInputChange}
            row="none"
            maxLength="500"
          ></textarea>

          <div className="caixaSalvarPadrao">
            <div className="InputAuthorization4">
              <label>
                <input
                  name="clsStatus"
                  type="checkbox"
                  defaultChecked={!!campos.clsStatus}
                  onChange={handleInputChange}
                />
                <span>Status</span>
              </label>
            </div>

            <button type="submit">Salvar Registro</button>
          </div>
        </form>
      </div>
    </>
  )
}
